<p-avatar
  [label]="initials"
  size="normal"
  shape="circle"
  [pTooltip]="clientName"
  [style]="{
    'background-color': 'var(--p-primary-200)',
    color: 'var(--p-primary-700)',
    'font-weight': '600',
    'font-size': '14px'
  }"
/>
